import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import {token, domain} from '../Security';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import loadingSpinner from './../../assets/loading.gif';
// icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function OvertimeSummaryReport({isHideSideMenu}) {
    const [date, setDate] = useState();
    const [errorState, setErrorState] = useState(false);
    const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    function formatDate(dateStr) {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    /* const generateDownloadTemplate = useCallback(async (data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
        let employeesInfo = [];
    
        const fetchPromises = data.map(async (item) => {
            const apiUrl = domain + "/api/Employee/";
    
            try {
                const response = await axios.get(apiUrl, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
    
                if (response.data) {
                    employeesInfo = response.data;
                } else {
                    console.error('Error fetching data: Response data is undefined');
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        });
    
        try {
            await Promise.all(fetchPromises);
        } catch (error) {
            console.error('Error fetching employee data:', error);
        }
    
        const dateRow = worksheet.addRow([`Date: ${formatDate(date)}`]);
        dateRow.getCell(1).font = { bold: true };
    
        const header = ['EMPLOYEE NAME', 'POSITION', 'AGENCY', 'WAREHOUSE', 'SHIFT', 'OFFICIAL SCHEDULE', 'ACTUAL IN / ABSENT'];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeeName', width: 30 },
            { key: 'position', width: 25 },
            { key: 'agency', width: 25 },
            { key: 'warehouse', width: 25 },
            { key: 'shift', width: 25 },
            { key: 'officialSchedule', width: 25 },
            { key: 'actualInAbsent', width: 25 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        data.forEach(item => {
            const dataWithInfo = employeesInfo.filter(employee => {
                return employee.id === item.employeePersonalInformationId;
            });
            worksheet.addRow([
                dataWithInfo[0].fullName,
                dataWithInfo[0].employeeInformation.positionDescription ? dataWithInfo[0].employeeInformation.positionDescription : null,
                dataWithInfo[0].employeeInformation.classificationDescription ? dataWithInfo[0].employeeInformation.classificationDescription : null,
                dataWithInfo[0].employeeInformation.departmentDescription ? dataWithInfo[0].employeeInformation.departmentDescription : null,
                dataWithInfo[0].employeeInformation.shiftScheduleShiftName ? dataWithInfo[0].employeeInformation.shiftScheduleShiftName : null,
                dataWithInfo[0].employeeInformation.shiftScheduleShiftName ? dataWithInfo[0].employeeInformation.shiftScheduleShiftName : null,
                "PRESENT"
            ]);
        });
    
        setLoading(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Overtime_Summary_Report.xlsx');
    }, [date]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/OvertimeRequest";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            const dataWithSpecificDate = response.data.filter(data => {
                const dateFromData = new Date(data.date);
                const dateToCompare = new Date(date);
            
                const dateRequested = `${dateFromData.getFullYear()}-${String(dateFromData.getMonth() + 1).padStart(2, '0')}-${String(dateFromData.getDate()).padStart(2, '0')}`;
                const formattedDate = `${dateToCompare.getFullYear()}-${String(dateToCompare.getMonth() + 1).padStart(2, '0')}-${String(dateToCompare.getDate()).padStart(2, '0')}`;
            
                return dateRequested === formattedDate;
            });

            console.log("TEST")

            generateDownloadTemplate(dataWithSpecificDate);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            // setLoading(false);
        }
    }, [generateDownloadTemplate, date]); */
    
    const generateDownloadTemplate = useCallback(async (data, employeeInfos) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
    
        const dateRow = worksheet.addRow([`Date: ${formatDate(date)}`]);
        dateRow.getCell(1).font = { bold: true };
    
        const header = ['EMPLOYEE NAME', 'POSITION', 'AGENCY', 'WAREHOUSE', 'TIME IN', 'TIME OUT', 'STATUS', 'OT RENDERED FROM', 'OT RENDERED TO', 'OT RENDERED TOTAL', 'SHIFT SCHEDULE', 'REASON'];
        const headerRow = worksheet.addRow(header);
    
        worksheet.columns = [
            { key: 'employeeName', width: 30 },
            { key: 'position', width: 25 },
            { key: 'agency', width: 25 },
            { key: 'warehouse', width: 25 },
            { key: 'timeIn', width: 25 },
            { key: 'timeOut', width: 25 },
            { key: 'status', width: 25 },
            { key: 'from', width: 25 },
            { key: 'to', width: 25 },
            { key: 'total', width: 25 },
            { key: 'shiftSchedule', width: 25 },
            { key: 'reason', width: 25 },
        ];
    
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        data.forEach(item => {
            const employee = employeeInfos.find(employeeInfo => employeeInfo.employeeId.toString() === item.employeeId.toString())
            
            worksheet.addRow([
                item.employeeName,
                item.position ? item.position : null,
                item.agency ? item.agency : null,
                employee.employeeInformation && employee.employeeInformation.locationId ?  employee.employeeInformation.locationDescription : null,
                item.timeIn ? item.timeIn : null,
                item.timeOut ? item.timeOut : null,
                !item.timeIn && !item.timeOut ? '' : !item.timeIn || !item.timeOut ? 'Inomplete attendance': 'Complete attendance',
                item.otFrom ? item.otFrom : null,
                item.otTo ? item.otTo : null,
                item.total ? item.total : null,
                employee.employeeInformation && employee.employeeInformation.shiftScheduleId ?  employee.employeeInformation.shiftScheduleShiftName : null,
                item.reason ? item.reason : null,
            ]);
        });
    
        setLoading(false);
    
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Overtime_Summary_Report.xlsx');
    }, [date]);

    const fetchDataEmployee = useCallback(async () => {
        const apiUrlEmployee =  domain + "/api/Employee";

        try {
            const response = await axios.get(apiUrlEmployee, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
                }
            });
            
            return response.data; // Return the response data
        } catch (error) {
            console.error('Error fetching data:', error);
            return []; // Return an empty array in case of error
        }
    }, []);
    
    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Report/warehouse-overtime-summary";

        const data = {
            date: date,
        };

        try {
            setLoading(true);
            const response = await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const employeeInfos = await fetchDataEmployee();

            generateDownloadTemplate(response.data, employeeInfos);
        } catch (error) {
            setLoading(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = error.response.data.message; // Fallback to general message
            setRequestMessage(errorMessage);
            console.error('Error fetching data:', error);
        } finally {
            // setLoading(false);
        }
    }, [generateDownloadTemplate, fetchDataEmployee, date]);

    const generate = () =>{
        if( !date
        ){
            setErrorState(true);
            return;
        }
        setErrorState(false);

        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Overtime Summary Report"}</span>
                            </div>
                            <h3>Generate Overtime Summary Report</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row">
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Date</div>
                                    <div className="info-item-input">
                                        <DateTimeInput date={date} setDate={setDate}/>
                                    </div>
                                    <span style={{
                                                visibility: !date && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="resignedGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
export default OvertimeSummaryReport
